import { FindingsList } from '../components/FindingsList';
import { SectionHeading } from '../program-evaluation.styled';
import { parseFindings } from '../utils/parseFindings';

export interface PatternsWorthInvestigatingProps {
  findingsText: string;
}

const EMPTY_STATE_COPY =
  "No additional notable findings surfaced in this generation. The findings in the prior sections cover this year's analysis.";

const BACKEND_NO_CANDIDATES_LINE =
  'No additional patterns surfaced this year beyond those described in the sections above.';

export function PatternsWorthInvestigating({ findingsText }: PatternsWorthInvestigatingProps) {
  const findings = parseFindings(findingsText).filter(
    (finding) => finding.text !== BACKEND_NO_CANDIDATES_LINE,
  );

  return (
    <section
      className="patterns-worth-investigating"
      data-testid="patterns-worth-investigating"
    >
      <SectionHeading id="patterns-worth-investigating-heading">
        Patterns Worth Investigating
      </SectionHeading>

      {findings.length > 0 ? (
        <FindingsList findings={findings} />
      ) : (
        <p
          className="patterns-worth-investigating-empty-state"
          data-testid="patterns-empty-state"
        >
          {EMPTY_STATE_COPY}
        </p>
      )}
    </section>
  );
}
